<template>
<div>
        <nav>
          <div class="navregular">
            <span>{{ this.$store.state.currentVersion }}</span>
            <router-link to="/">The Chinese Type Archive</router-link>
            <router-link to="/about">About the Archive</router-link>
          </div>
          <div class="navmobile">
                <router-link to="/records">View Records</router-link>
                <router-link to="/about">About the Archive</router-link>
                <span class="menubutton" @click="menuButtonClicked"></span>
            </div>
        </nav>
        
        <header>
            <div>
                <h2 class="header_main_eng">Record Entries</h2>
                <h2 class="header_main_ch">紀錄</h2>
            </div>
            <router-link to="/records/typeface" tag="div" :class="['subnav', this.$store.state.currentRecordType === 'typeface' ? 'subnav_selected' : '']">
                <p class="header_main_ch">字體</p>
                <p class="header_main_eng">Typefaces ({{ this.$store.getters.typefaceDataLength }})</p>
            </router-link>
            <router-link to="/records/concept" tag="div" :class="['subnav', this.$store.state.currentRecordType === 'concept' ? 'subnav_selected' : '']">
                <p class="header_main_ch">詞匯</p>
                <p class="header_main_eng">Concepts ({{ this.$store.getters.conceptDataLength }})</p>
            </router-link>
            <router-link to="/records/resource" tag="div" :class="['subnav', this.$store.state.currentRecordType === 'resource' ? 'subnav_selected' : '']">
                <p class="header_main_ch">書刊</p>
                <p class="header_main_eng">Resources ({{ this.$store.getters.resourceDataLength }})</p>
            </router-link>
        </header>
        <section class="mainbody">
            <!-- Will have different tables for Concepts, References, Typefaces -->
            <RecordtableTypefaces v-if="(this.$store.state.currentRecordType === 'typeface') && this.$store.state.fetchedTypefaceData" :recordsettoshow=typefaces :initiallyselectedrecordid=initiallyselectedrecordidtypeface />
            <RecordtableConcepts v-if="(this.$store.state.currentRecordType === 'concept') && this.$store.state.fetchedConceptData" :recordsettoshow=concepts :initiallyselectedrecordid=initiallyselectedrecordidconcept />
            <RecordtableResources v-if="(this.$store.state.currentRecordType === 'resource') && this.$store.state.fetchedResourceData" :recordsettoshow=resources :initiallyselectedrecordid=initiallyselectedrecordidresource />
        </section>
</div>
</template>


<script>

import RecordtableConcepts from '@/components/RecordtableConcepts.vue'
import RecordtableTypefaces from '@/components/RecordtableTypefaces.vue'
import RecordtableResources from '@/components/RecordtableResources.vue'

export default {
  name: 'RecordViewMain',
  components: {
    RecordtableConcepts,
    RecordtableTypefaces,
    RecordtableResources
  },
  computed: {
      typefaces: function(){
          return this.$store.state.fetchedTypefaces
      },
      concepts: function(){
          return this.$store.state.fetchedConcepts
      },
      resources: function(){
          return this.$store.state.fetchedResources
      },
      initiallyselectedrecordidtypeface: function() {    //treat 'typeface' like a variable; can be used just like a piece of data
        //Check to see if recordtype is typeface
        if(this.$store.state.currentRecordType === 'typeface' && this.$store.state.fetchedTypefaceData){
          //Check to see if params value is null/empty/undefined; if so, then use the default/current recordid value
          if(this.$route.params.recordid == null){
              /* eslint-disable no-console */
        console.log('TYPEFACE RECORD ID IS ' + this.$store.state.currentTypefaceRecordID)
        /* eslint-enable no-console */
              return this.$store.state.currentTypefaceRecordID
          }else {
            //If params value is not empty, then filter on dataset based on the recordid
            //Returns an temp array that is the result of filtering the typeface record dataset
            var temparray = this.typefaces.filter(item => { 
                /* eslint-disable no-console */
        console.log('TYPEFACE RECORD ID IS ' + this.$store.state.currentTypefaceRecordID)
        /* eslint-enable no-console */
              return item.recordid === this.$route.params.recordid 
            })
            //If the a value is returned, then show it
            if(temparray.length > 0){
              //Filtering the typeface record dataset returns an object is an array of 1 array. We are going to return the inside array
              /* eslint-disable no-console */
        console.log('TYPEFACE RECORD ID IS ' + this.$store.state.currentTypefaceRecordID)
        /* eslint-enable no-console */
              return temparray[0].recordid
            }else {
              //If no value is returned (meaning that the id is bogus), then use default/current recordid value
              /* eslint-disable no-console */
        console.log('TYPEFACE RECORD ID IS ' + this.$store.state.currentTypefaceRecordID)
        /* eslint-enable no-console */
              return this.$store.state.currentTypefaceRecordID
            }
          }
        }else { //If recordtype is not typeface, then return empty
        /* eslint-disable no-console */
        console.log('TYPEFACE RECORD ID IS ' + this.$store.state.currentTypefaceRecordID)
        /* eslint-enable no-console */
          return this.$store.state.currentTypefaceRecordID
        }   
      },
      initiallyselectedrecordidconcept: function() {    //treat 'concept' like a variable; can be used just like a piece of data
        //Check to see if recordtype is concept
        if(this.$store.state.currentRecordType === 'concept' && this.$store.state.fetchedConceptData){
          //Check to see if params value is null/empty/undefined; if so, then use the default/current recordid value
          if(this.$route.params.recordid == null){
                      /* eslint-disable no-console */
        console.log('CONCEPT RECORD ID IS ' + this.$store.state.currentConceptRecordID)
        /* eslint-enable no-console */
              return this.$store.state.currentConceptRecordID
          }else {
            //If params value is not empty, then filter on dataset based on the recordid
            //Returns an temp array that is the result of filtering the concept record dataset
            var temparray = this.concepts.filter(item => { 
                /* eslint-disable no-console */
        console.log('CONCEPT RECORD ID IS ' + this.$store.state.currentConceptRecordID)
        /* eslint-enable no-console */
              return item.recordid === this.$route.params.recordid 
            })
            //If the a value is returned, then show it
            if(temparray.length > 0){
              //Filtering the concept record dataset returns an object is an array of 1 array. We are going to return the inside array
              /* eslint-disable no-console */
                console.log('CONCEPT RECORD ID IS ' + this.$store.state.currentConceptRecordID)
                /* eslint-enable no-console */
              return temparray[0].recordid
            }else {
              //If no value is returned (meaning that the id is bogus), then use default/current recordid value
              /* eslint-disable no-console */
        console.log('CONCEPT RECORD ID IS ' + this.$store.state.currentConceptRecordID)
        /* eslint-enable no-console */
              return this.$store.state.currentConceptRecordID
            }
          }
        }else { //If recordtype is not concept, then return empty
        /* eslint-disable no-console */
        console.log('CONCEPT RECORD ID IS ' + this.$store.state.currentConceptRecordID)
        /* eslint-enable no-console */
          return this.$store.state.currentConceptRecordID
        }    
      },
      initiallyselectedrecordidresource: function() {    //treat 'resource' like a variable; can be used just like a piece of data
        //Check to see if recordtype is resource
        if(this.$store.state.currentRecordType === 'resource'&& this.$store.state.fetchedResourceData){
          //Check to see if params value is null/empty/undefined; if so, then use the default/current recordid value
          if(this.$route.params.recordid == null){
              /* eslint-disable no-console */
        console.log('RESOURCE RECORD ID IS ' + this.$store.state.currentResourceRecordID)
        /* eslint-enable no-console */
              return this.$store.state.currentResourceRecordID
          }else {
            //If params value is not empty, then filter on dataset based on the recordid
            //Returns an temp array that is the result of filtering the resource record dataset
            var temparray = this.concepts.filter(item => { 
                /* eslint-disable no-console */
        console.log('RESOURCE RECORD ID IS ' + this.$store.state.currentResourceRecordID)
        /* eslint-enable no-console */
              return item.recordid === this.$route.params.recordid 
            })
            //If the a value is returned, then show it
            if(temparray.length > 0){
              //Filtering the resource record dataset returns an object is an array of 1 array. We are going to return the inside array
              /* eslint-disable no-console */
        console.log('RESOURCE RECORD ID IS ' + this.$store.state.currentResourceRecordID)
        /* eslint-enable no-console */
              return temparray[0].recordid
            }else {
              //If no value is returned (meaning that the id is bogus), then use default/current recordid value
              /* eslint-disable no-console */
        console.log('RESOURCE RECORD ID IS ' + this.$store.state.currentResourceRecordID)
        /* eslint-enable no-console */
              return this.$store.state.currentResourceRecordID
            }
          }
        }else { //If recordtype is not resource, then return empty
        /* eslint-disable no-console */
        console.log('RESOURCE RECORD ID IS ' + this.$store.state.currentResourceRecordID)
        /* eslint-enable no-console */
          return this.$store.state.currentResourceRecordID
        }     
        
      }
  },
  data(){
        return {

            }
   },
   methods: {
    menuButtonClicked(){
      if(this.$store.state.menuOpened){
        this.$store.state.menuOpened=false;
      }else {
        this.$store.state.menuOpened=true;
      }
    }
  }
}
</script>

<style>
</style>
